import { Calendar } from "components/calendar";
import { HEADER_CONTENT_PORTAL_ID } from "utils";
import { Portal } from "@radix-ui/react-portal";
import TimeSheetReviewLayout from "../layout";
import TimesheetDayCell from "./_Cell";
import useMonthlyTimesheet from "./hooks/useMonthlyTimesheet";
import { usePortal } from "hooks";
import { useState } from "react";

export default function TimesheetReviewCalendar() {
  const [date, setDate] = useState(new Date());
  const { transformedData, isLoading } = useMonthlyTimesheet(date);
  const headerContentPortal = usePortal({
    elementId: HEADER_CONTENT_PORTAL_ID,
  });
  return (
    <div className="h-full w-full">
      <TimeSheetReviewLayout>
        <Portal container={headerContentPortal}>
          <h2 className="text-2xl font-semibold">Calendar</h2>
        </Portal>
        <Calendar
          key={transformedData?.id}
          date={date}
          setDate={setDate}
          events={transformedData}
          renderDay={TimesheetDayCell}
          isLoading={isLoading}
          isHeaderPortal={true}
        />
      </TimeSheetReviewLayout>
    </div>
  );
}
